// Tiny pub/sub used by the API layer to forward 401/403/404 (and other) errors
// to a React-tree-mounted handler. The QueryClient is created outside the React
// tree, so it can't use hooks/router directly. This bus bridges the two.

const listeners = new Set();

export function subscribeApiError(handler) {
    listeners.add(handler);
    return () => listeners.delete(handler);
}

export function notifyApiError(error) {
    if (!error) return;
    listeners.forEach((handler) => {
        try {
            handler(error);
        } catch (_e) {
            // never let a listener crash the API layer
        }
    });
}
